import {
  TouringCardTableHead,
  TouringCardTableRow,
  TouringCardTableRowLabel,
} from '@common';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'VENUE_OPERATOR_CONTACT_PERSONS.ROWS';

export const ContactPersonsHeader: React.FC = () => {
  const { t } = useTranslation('venueDetailsGeneral');

  return (
    <TouringCardTableHead>
      <TouringCardTableRow>
        <TouringCardTableRowLabel>
          {t(`${TRANS_PATH}.NAME`)}
        </TouringCardTableRowLabel>
        <TouringCardTableRowLabel>
          {t(`${TRANS_PATH}.JOB_TITLE`)}
        </TouringCardTableRowLabel>
        <TouringCardTableRowLabel>
          {t(`${TRANS_PATH}.CONTACT_DETAILS`)}
        </TouringCardTableRowLabel>
      </TouringCardTableRow>
    </TouringCardTableHead>
  );
};
